'use client';

import { Entry } from '@/lib/parsers/entries';
import Flex from '../ui/Flex';
import NextAnchor from '../ui/NextAnchor';
import Txt from '../ui/Txt';
import * as styles from './PageHeader.css';

const PageProfile = (props: Partial<Entry<'profile'>>) => {
  const { title, uri, showOnWebsite } = props;

  if (!showOnWebsite || !uri) return title;

  return (
    <NextAnchor href={uri} className={styles.pageMetaFeature}>
      {title}
    </NextAnchor>
  );
};

type PageProfilesProps = {
  profileMultiple?: Partial<Entry<'profile'>>[] | null;
};

export default function PageProfiles({ profileMultiple }: PageProfilesProps) {
  if (!profileMultiple?.length) return null;

  return (
    <Flex direction="row" wrap>
      {profileMultiple.map((profile, i) => (
        <Txt as="span" variant="body" key={i}>
          {profileMultiple.length && i === 0 && <Txt>By </Txt>}
          <PageProfile {...profile} />
          {i === profileMultiple.length - 2 ? (
            <Txt>&nbsp;and&nbsp;</Txt>
          ) : i === profileMultiple.length - 1 ? (
            ''
          ) : (
            <Txt>,&nbsp;</Txt>
          )}
        </Txt>
      ))}
    </Flex>
  );
}
